export const ENDPOINT_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const DOMAIN_BASE_URL = process.env.REACT_APP_DOMAIN_BASE_URL
